import { MILLISECONDS_IN_MINUTE } from '@stdlib/constants-time';
import type { QueryKey, UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import type { RoomStatus } from 'app/typings/core/admin/rooms/enum/roomStatus';
import type { SearchRoomResponse } from 'app/typings/core/admin/rooms/roomList';
import { apiRequest } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export type RoomsListQueryParam = {
  search?: string;
  sorting?: string;
  status?: RoomStatus[];
  pageNumber?: number;
};

export function useRooms(
  queryParams: RoomsListQueryParam = {},
  options?: Omit<
    UseQueryOptions<SearchRoomResponse, Error, SearchRoomResponse, QueryKey>,
    'queryKey' | 'queryFn'
  >
) {
  const formattedQueryParams = useMemo(
    () => ({ ...queryParams }),
    [queryParams]
  );

  const queryKey = useMemo(
    () => [CORE_QUERY_KEYS.rooms, formattedQueryParams],
    [formattedQueryParams]
  );

  return useQuery<SearchRoomResponse>({
    queryKey,
    queryFn: () =>
      apiRequest({
        path: ENDPOINTS.getRooms,
        queryParams: formattedQueryParams,
      }) as Promise<SearchRoomResponse>,
    staleTime: 5 * MILLISECONDS_IN_MINUTE,
    ...options,
  });
}
